import React from "react";
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk';
import reducers from '../abloy_keys_react_app/reducers'
import ApartmentTransfer from './components/ApartmentTransfer'
import LeaseKeys from './components/LeaseKeys'

const AbloyKeys = () => {
  const node = document.getElementById('transfer_data');
  if (!node) {return null}
  //apartment transfer
  const transfer = node.getAttribute('transfer');
  const old_lease  = node.getAttribute('old_lease');
  const new_lease = node.getAttribute('new_lease');
  const data = transfer ? JSON.parse(transfer) : null;
  //lease keys
  const lease_data = node.getAttribute('lease');
  const keys_data  = node.getAttribute('keys');
  const lostkeys_data = node.getAttribute('lostkeys');
  const brokenkeys_data = node.getAttribute('brokenkeys');
  const lease = lease_data ? JSON.parse(lease_data) : null;

  if (data && data.apartment) {
    const data_old_lease = old_lease ? JSON.parse(old_lease) : {};
    const data_new_lease = new_lease ? JSON.parse(new_lease) : {};
    data.old_lease = data_old_lease.old_lease;
    data.new_lease = data_new_lease.new_lease;
    //check which view to render //for next development
    if (data.apartment.abloy_profile) {
      return <ApartmentTransfer transfer={data} />
    }
  } else if (lease && lease.apartment) {
    const keys = keys_data ? JSON.parse(keys_data) : [];
    const lostkeys = lostkeys_data ? JSON.parse(lostkeys_data) : [];
    const brokenkeys = brokenkeys_data ? JSON.parse(brokenkeys_data) : [];
    return <LeaseKeys lease={lease} keys={keys} lostkeys={lostkeys} brokenkeys={brokenkeys} />
  }
};

const createReduxStore = () => {
  return createStore(
    reducers,
    compose(
      applyMiddleware(thunk),
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  );
};

const AbloyKeysApp = () => {
  return (
    <Provider store={createReduxStore()}>
      <AbloyKeys />
    </Provider>
  );
};

export default AbloyKeysApp;
